import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Development\\frontend\\express-shina\\src\\routes\\About\\About.tsx");
